var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.3864 49.5876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3a404e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_2",
    "data-name": "Lager 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "deelo-icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.6912,49.5876c10.9317,0,23.6951-2.0106,23.6951-7.6806.0234-6.1834-5.0206-11.624-13.16-14.2023l-.9917-.3112.77-.7a15.3313,15.3313,0,1,0-23.38-3.3755,15.7391,15.7391,0,0,0,2.8078,3.3755l.77.7-.9917.3112C5.0633,30.2868,0,35.7313,0,41.9069,0,47.5769,12.7634,49.5876,23.6912,49.5876ZM12.9345,16.0223h-.0039v-.6534A10.7575,10.7575,0,1,1,23.6912,26.1376h-.0233A10.7839,10.7839,0,0,1,12.9345,16.0223ZM4.5694,41.3857c.4823-5.9072,9.069-10.7181,19.1335-10.7181,10.0722,0,18.6473,4.8106,19.114,10.7217l.035.4317-.4006.1672A41.7988,41.7988,0,0,1,26.46,45.1776q-1.4058,0-2.8117-.0972h-.0077C11.85,45.08,5.95,42.7393,4.8144,41.9187l-.2722-.1944Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3d674bb4eda53154d92b3e3e74f76166.svg";
export { ForwardRef as ReactComponent };